import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TransactionVM, Order } from '../../../../../models/orderModel';
import { BackOffice24OrderTransactionDetailsComponent } from '../back-office24-order-transaction-details/back-office24-order-transaction-details.component';
import { BackOffice24OrderTransactionCreateComponent } from '../back-office24-order-transaction-create/back-office24-order-transaction-create.component';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { BackOffice24OrderAddAdditionalServicesComponent } from '../back-office24-order-add-additional-services/back-office24-order-add-additional-services.component';
import { BackOffice24OrderTransactionManagerComponent } from '../back-office24-order-transaction-manager/back-office24-order-transaction-manager.component';

@Component({
  selector: 'app-back-office24-order-transaction',
  templateUrl: './back-office24-order-transaction.component.html',
  styleUrl: './back-office24-order-transaction.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderTransactionComponent implements OnInit, OnDestroy {
  @Input() transactions: Observable<TransactionVM[]>;
  @Input() order: Order;
  @Output() createAdditionalService = new EventEmitter<void>();
  dataSource: MatTableDataSource<TransactionVM>;
  canCreateTransaction: boolean = true;
  @Input() orderAdditionalServices: any[];
  @Input() allAdditionalServices: any[];

  displayedColumns: string[] = [
    'transactionNr',
    'amount',
    'vatAmount',
    'amountIncVat',
    'remainingReversalAmount',
    'paymentStatus',
    'paymentType',
    'paymentDate',
    'debitCreditType',
    'created'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public backOfficeService: BackOfficeService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.transactions.pipe(
      takeUntil(this.componentDestroyed$)
    ).subscribe(data => {
      this.setTransactionsTable(data);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getTransactions() {
    this.backOfficeService
      .getTransactions(this.order.orderId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderTransactions => {
        this.setTransactionsTable(orderTransactions);
      });
  }

  setTransactionsTable(orderTransactions: TransactionVM[]){
    if (orderTransactions && orderTransactions?.length > 0) {
      this.dataSource = new MatTableDataSource<TransactionVM>(orderTransactions);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.canCreateTransaction = true;
      orderTransactions.forEach(transaction => {
        if (transaction?.paymentStatus?.toLowerCase() == 'checkout' || transaction?.paymentStatus?.toLowerCase() == 'new') {
          this.canCreateTransaction = false;
        }
      });

      if( this.order.status === 'Cancelled' || this.order.status === 'Checkout' ) {
        this.canCreateTransaction = false;
      }
    }
  }

  // createTransaction() {
  //   let dialogRef = this.dialog.open(BackOffice24OrderTransactionCreateComponent, {
  //     // height: '1010px',
  //     width: '720px',
  //     hasBackdrop: true,
  //     data: this.order
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.getTransactions();
  //   });
  // }

  transactionDetails(transaction: TransactionVM): void {
    let dialogRef = this.dialog.open(BackOffice24OrderTransactionDetailsComponent, {
      // height: '1010px',
      width: '720px',
      hasBackdrop: true,
      data: transaction
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getTransactions();
    });
  }

addOrderAdditionalService(): void {
    const dialogRef = this.dialog.open(BackOffice24OrderTransactionManagerComponent, {
      // height: '1010px',
      width: '720px',
      hasBackdrop: true,
      data: {
        order: this.order,
        orderId: this.order.orderId,
        orderAdditionalServices: this.orderAdditionalServices,
        allAdditionalServices: this.allAdditionalServices
      }
    });
    dialogRef.afterOpened().subscribe(() => {
      const componentInstance = dialogRef.componentInstance as BackOffice24OrderTransactionManagerComponent;
      componentInstance.saveChangesEvent.subscribe(() => {
        // this.getTransactions();
        this.createAdditionalService.emit();
      });
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
